import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Calendar } from "./components/Calendar";
import "./styles/App.css";
import ProtectedRoute from "./authentication/ProtectedRoute";

const Pages = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<ProtectedRoute component={Calendar} requiredRole="Admin" />}
        />
      </Routes>
    </Router>
  );
};

const App = () => {
  return <Pages />;
};

export default App;
